import { useEffect, useState } from 'react';
import { useLiveReading } from '../contexts/LiveReadingContext';
import { useReadingsProcessor } from './useReadingProcessor';
import useDataPointsByHardwareProfileId from '../data/datapoint/useDataPointsByHardwareProfile';
import { IAppliance } from '../types/Appliance/Appliance';
import { ITemplateConfiguration } from '../types/Template/Template';

export function useReadingsDisplayData(
  selectedAppliance: IAppliance,
  selectedTemplate?: ITemplateConfiguration
) {
  const { dataPoints } = useDataPointsByHardwareProfileId(
    selectedAppliance.id,
    selectedTemplate?.id === '-2' ? undefined : selectedTemplate?.id,
    selectedTemplate?.id === '-2' ? undefined : selectedTemplate?.ownerId
  );
  const { latest, latestTimestamp, loading, readingUnavailable } =
    useLiveReading();
  const { processorReady } = useReadingsProcessor();
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (
      processorReady &&
      !loading &&
      !dataPoints.isLoading &&
      dataPoints.data
    ) {
      setIsLoading(false);
    }
  }, [processorReady, loading, dataPoints.isLoading, dataPoints.data]);

  return {
    dataPoints,
    latest,
    latestTimestamp,
    loading,
    readingUnavailable,
    isLoading,
  };
}
